export default "__VITE_ASSET__BDlRxDoC__"